import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CreateTypeOfCallSopReportMappingDto, TypeOfCallSopReportMappingDto, TypeOfCallSopReportMappingService } from 'source/app/proxy/type-of-calls';
import { PagedRequestDto } from 'source/app/xui/x-page/x-pg-model/x-pg.model';

@Component({
    selector: 'app-type-of-call-sop-report-mapping',
    templateUrl: './type-of-call-sop-report-mapping.component.html',
    styleUrls: ['./type-of-call-sop-report-mapping.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TypeOfCallSopReportMappingComponent implements OnInit {

  searchValue = '';
  showColumnFilters = false;
  columnFilters: { [key: string]: string } = {};
  isEditMode = false;
  isVisible = false;
  isOkLoading = false;
  data: TypeOfCallSopReportMappingDto[] = [];
  filteredData: any[] = []; 
  tableHeight = 535;
  typeOfCallId: string;
  sopReports: { id: string; code: string; name: string }[] = [];
  mappedSopReports: any[] = []; 
  sopReportForm: FormGroup;
  selectedReport: TypeOfCallSopReportMappingDto;
  

  constructor(
    private inj: Injector,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private nzMessageService: NzMessageService,
    private typeOfCallSopReportMappingService: TypeOfCallSopReportMappingService
  ) {
      this.typeOfCallId = this.route.parent?.snapshot.params.id;
   }

    onSearch(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase().trim();
    this.searchValue = searchTerm;
    this.applyFilters();
  }
  ngOnInit(): void {
    this.getSOPReport();
    this.initializeForm();
    this.updateTableHeight();
    this.getSOPReportList();
  }

  initializeForm() {
    this.sopReportForm = this.formBuilder.group({
      typeOfCallId: [this.typeOfCallId],
      sopReportId: [null, Validators.required],
    });
  }

  showModal(): void {
    this.isEditMode = false;
    this.selectedReport = null;
    this.sopReportForm.reset({
      typeOfCallId: this.typeOfCallId,
      sopReportId: null,
    });
    this.isVisible = true;
  }

  getSOPReport(){
      this.typeOfCallSopReportMappingService
    .getListByTypeOfCall(this.typeOfCallId)
    .subscribe(s => {
      this.data = s;

      this.filteredData = [...this.data];
    });
  }

  getSOPReportList(){
    this.typeOfCallSopReportMappingService.getAllSopReports().subscribe(res => {
      this.mappedSopReports = res;
      this.sopReports = res.map(x => ({
        id: x.id,
        code: x.code,
        name: x.name 
      }));
    });
  }

  handleSave(){
    this.sopReportForm.patchValue({
      typeOfCallId: this.typeOfCallId
    });

    if (this.sopReportForm.get('sopReportId')?.value == null) {
    this.nzMessageService.error("Please select a SOP Report");
    return;
  }

  this.typeOfCallSopReportMappingService.create(this.sopReportForm.value).subscribe({
    next: () => {
      this.nzMessageService.success("Saved successfully!");
      this.isVisible = false;
      this.isOkLoading = false;
      this.getSOPReport();
      this.getSOPReportList();
    },
    error: err => {
      this.nzMessageService.error(err.error.error.message);
    }
  });
  }

  deleteSOPReport(id: string){
    this.typeOfCallSopReportMappingService.delete(id).subscribe({
      next: () => {
        this.data = this.data.filter(item => item.id !== id);
        this.applyFilters();
        this.nzMessageService.success('Successfully deleted SOP Report');
      },
      error: (error) => {
        this.nzMessageService.warning('Failed to delete');
        console.error('Error deleting vessel status mapping:', error);
      }
    });
  }

  handleCancel(){
    this.isVisible = false;
    this.isEditMode = false;
    this.selectedReport = null;
    this.isOkLoading = false;
  }

  toggleColumnFilters(): void {
    this.showColumnFilters = !this.showColumnFilters;
    if (!this.showColumnFilters) {
      this.columnFilters = {};
      this.applyFilters();
    }
  }
  
  updateTableHeight() {
    const screenHeight = window.innerHeight;

    if (screenHeight < 1080) {
      this.tableHeight = 535;
    } else if (screenHeight > 1080) {
      this.tableHeight = 750;
    }
  }

  updateColumnFilter(column: string, event: Event): void {
    const value = (event.target as HTMLInputElement).value.toLowerCase().trim();

    if (value) {
      this.columnFilters[column] = value;
    } else {
      delete this.columnFilters[column];
    }

    this.applyFilters();
  }

  applyFilters(): void {
    let filtered = [...this.data];

    // Apply global search
    if (this.searchValue) {
      filtered = filtered.filter(item =>
        (item.sopReportCode?.toLowerCase() || '').includes(this.searchValue) ||
        (item.sopReportName?.toLowerCase() || '').includes(this.searchValue)
      );
    }

    // Apply column filters
    Object.keys(this.columnFilters).forEach(column => {
      const filterValue = this.columnFilters[column];

      switch (column) {
        case 'sopReportCode':
          filtered = filtered.filter(item =>
            (item.sopReportCode?.toLowerCase() || '').includes(filterValue)
          );
          break;
        case 'sopReportName':
          filtered = filtered.filter(item =>
            (item.sopReportName?.toLowerCase() || '').includes(filterValue)
          );
          break;
      }
    });

    this.filteredData = filtered;
  }

  get isSaveDisabled(): boolean {
    return this.sopReportForm.invalid || this.isOkLoading;
  }

sortSopReportCode = (a: any, b: any) => (a.sopReportCode || '').localeCompare(b.sopReportCode || '');
sortSopReportName = (a: any, b: any) => (a.sopReportName || '').localeCompare(b.sopReportName || '');
}
